import { Button, Form, Icon, Modal, Notification } from "@cea/ui-kit";
import PropTypes from "prop-types";
import { useContext, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import FileUploadContext from "../../../contexts/FileUploadContext";
import OrganizationContext from "../../../contexts/OrganizationContext";
import { getNotification } from "../../../utils";
import { createSCMFiles } from "../../../utils/createFiles";

import ReportUploadForm from "./components/ReportUploadForm";

export const SCMReportUploadModal = ({
  isVisible,
  onFileCreate,
  onFileUpdate,
  handleCancel,
  parentId: parentFolderId,
  shouldAllowZip,
  onFolderCreate,
}) => {
  const [form] = Form.useForm();
  const [query] = useSearchParams();
  const { service } = useContext(OrganizationContext);

  const { organization } = useContext(OrganizationContext);

  const { showUploadProgressNotification } = useContext(FileUploadContext);

  useEffect(() => {
    if (isVisible) {
      form.resetFields();
    }
  }, [isVisible]);

  const resetForm = () => {
    form.resetFields();
  };

  const onFormSubmit = async () => {
    try {
      const folderId = query.get("folderId");

      showUploadProgressNotification({
        formValues: form.getFieldsValue(),
        createFiles: createSCMFiles,
        serviceType: service.serviceType,
        parentId: parentFolderId || folderId,
        metadata: {
          organizationId: organization.id,
        },
      });

      form.resetFields();
      Notification.success({ message: "File Upload in Progress" });
      handleCancel();
    } catch (error) {
      const message = getNotification(error);

      Notification.error({
        message,
      });
    }
  };

  return (
    <>
      <Modal
        title="Upload Report"
        visible={isVisible}
        onOk={onFormSubmit}
        onCancel={handleCancel}
        centered
        width={720}
        footer={[
          <Button
            key="submit"
            type="primary"
            onClick={async () => {
              const isFormValid = await form.validateFields();

              if (isFormValid) {
                onFormSubmit();
              }
            }}
            className="ml-auto"
            icon={<Icon name="plus" size={14} color="#fff" />}
          >
            Save
          </Button>,
        ]}
      >
        <ReportUploadForm
          resetForm={resetForm}
          formInstance={form}
          shouldAllowZip={shouldAllowZip}
        />
      </Modal>
    </>
  );
};

SCMReportUploadModal.defaultProps = {
  isVisible: false,
  onFileCreate: () => {},
  onFileUpdate: () => {},
  handleCancel: () => {},
  parentId: null,
  shouldAllowZip: false,
  onFolderCreate: () => {},
};

SCMReportUploadModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onFileCreate: PropTypes.func.isRequired,
  onFileUpdate: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  parentId: PropTypes.string,
  shouldAllowZip: PropTypes.bool,
  onFolderCreate: PropTypes.func,
};

export default SCMReportUploadModal;
